import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "square",
      "stroke-width": "2",
      d: "m2 18 6.799-6.729M18 2l-6.726 6.828m0 0L18 18h-4.267l-4.934-6.729m2.475-2.443L6.267 2H2l6.799 9.271"
    }, null, -1)
  ]))]))
}
export default { render: render }